import { toast } from "react-toastify";
import {
  isRejectedWithValue,
  Middleware,
  MiddlewareAPI,
  PayloadAction,
} from "@reduxjs/toolkit";

import { HTTP_STATUS, MESSAGES } from "../helpers/constants";
import { IErrorResponse } from "../types/Error";

import { signOut } from "./user/slice";
import { RootState } from "./store";

/**
 * Log a warning and show a toast!
 */
export const rtkQueryErrorLogger: Middleware =
  (api: MiddlewareAPI) =>
  (next) =>
  (action: PayloadAction<Response & { data: IErrorResponse }>) => {
    if (isRejectedWithValue(action)) {
      let errorMessage = MESSAGES.ERROR_HAPPENED;

      const errorData = action.payload.data;
      const status = action.payload.status;

      if (errorData) {
        errorMessage = action.payload.data.message;
      }

      toast.error(errorMessage);

      switch (status) {
        case HTTP_STATUS.UNAUTHORIZED:
          if ((api.getState() as RootState).userSlice.token) {
            api.dispatch(signOut());
          }
          return;
        default:
      }
    }

    return next(action);
  };
